import styled from 'styled-components'
import { AnimateLetterboxWrapper } from '../animation/AnimateLetterbox/index.style'

export const ImageContentFixedMain = styled.div`
  background: ${props => props.bgColor};
`

export const ImageContentFixedWrapper = styled.div`
  height: 100%;
`

export const ImageContenFixedText = styled.div`
  color: ${props => props.color};

  * + ${AnimateLetterboxWrapper}, ${AnimateLetterboxWrapper} + * {
    margin-top: 4.2rem;
  }
`

export const ImageContentFixedMedia = styled.div`
  max-width: 90rem;
  margin-left: ${props => (!props.alignLeft ? 'auto' : undefined)};
  margin-right: ${props => (props.alignLeft ? 'auto' : undefined)};
  position: relative;
`
